import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from "@nebular/auth";

import { NbDialogRef, NbThemeService } from "@nebular/theme";
import { EMAIL_PATTERN } from "../../@auth/components/constants";
import { getDeepFromObject } from "../../@auth/helpers";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";

@Component({
  selector: "ngx-dialog-auth-login",
  templateUrl: "dialog-auth-login.component.html",
  styleUrls: ["dialog-auth-login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogAuthLoginComponent implements OnInit {
  @Input() mode?: string = "";

  minLength: number = this.getConfigValue(
    "forms.validation.password.minLength"
  );
  maxLength: number = this.getConfigValue(
    "forms.validation.password.maxLength"
  );
  redirectDelay: number = this.getConfigValue("forms.login.redirectDelay");
  showMessages: any = this.getConfigValue("forms.login.showMessages");
  strategy: string = this.getConfigValue("forms.login.strategy");
  socialLinks: NbAuthSocialLink[] = this.getConfigValue(
    "forms.login.socialLinks"
  );
  rememberMe = this.getConfigValue("forms.login.rememberMe");
  isEmailRequired: boolean = this.getConfigValue(
    "forms.validation.email.required"
  );
  isPasswordRequired: boolean = this.getConfigValue(
    "forms.validation.password.required"
  );

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  loginForm: FormGroup;
  alive: boolean = true;
  returnUrl: string;

  get email() {
    return this.loginForm.get("email");
  }
  get password() {
    return this.loginForm.get("password");
  }

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    private fb: FormBuilder,
    protected router: Router,
    private activatedRoute: ActivatedRoute,
    public userService: UserService,
    protected ref: NbDialogRef<DialogAuthLoginComponent>
  ) {}

  ngOnInit(): void {
    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];
    this.isEmailRequired && emailValidators.push(Validators.required);

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.loginForm = this.fb.group({
      email: this.fb.control("", [...emailValidators]),
      password: this.fb.control("", [...passwordValidators]),
      rememberMe: this.fb.control(false),
    });

    this.returnUrl =
      this.activatedRoute.snapshot.queryParams.returnUrl || "/home";
  }

  login(): void {
    this.user = this.loginForm.value;
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    // this.userService
    //   .signIn(this.user.email, this.user.password)
    //   .then((result) => {
    //     this.submitted = false;
    //     console.log(result);
    //     console.log("DialogAuthLoginComponent/login:", result);
    //     this.ref.close(result);
    //   })
    //   .catch((err) => {
    //     this.submitted = false;
    //     this.errors.push(err);
    //   });

    this.service
      .authenticate(this.strategy, this.user)
      .subscribe((result: NbAuthResult) => {
        this.submitted = false;

        if (result.isSuccess()) {
          this.messages = result.getMessages();
          console.log(
            "DialogAuthLoginComponent/login:",
            result.getResponse().user
          );
          this.ref.close(result.getResponse().user);
        } else {
          this.errors = result.getErrors();
        }

        const redirect = result.getRedirect();
        if (redirect) {
          setTimeout(() => {
            //return this.router.navigateByUrl(redirect);
            return this.router.navigateByUrl(this.returnUrl);
          }, this.redirectDelay);
        }
      });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  cancel() {
    this.ref.close();
  }
}
